/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */
import React from 'react';

import { jsx } from '@atlaskit/css';
import type { ConversationAction } from '@atlassian/rovo-conversation-actions';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import type { AISmartButtonProps } from '../common/types/shared-types';

// Lazy load to avoid loading useRovoActionTrigger when action shortcuts are not needed
const LazyAIActionShortcut = React.lazy(() =>
	import(/* webpackChunkName: "@atlaskit-internal_ai-action-shortcut" */ './main').then(
		(module) => ({
			default: module.AIActionShortcut,
		}),
	),
);

const LazyActionShortcutIconOnly = React.lazy(() =>
	import(/* webpackChunkName: "@atlaskit-internal_ai-action-shortcut" */ './main').then(
		(module) => ({
			default: module.ActionShortcutIconOnly,
		}),
	),
);

type AIActionShortcutProps = Pick<AISmartButtonProps, 'product' | 'sidebarApi'> & {
	action: ConversationAction;
};

export const AIActionShortcut = ({ action, sidebarApi, product }: AIActionShortcutProps) => {
	return (
		<React.Suspense fallback={null}>
			<LazyAIActionShortcut action={action} sidebarApi={sidebarApi} product={product} />
		</React.Suspense>
	);
};

export const ActionShortcutIconOnly = ({ action, sidebarApi, product }: AIActionShortcutProps) => {
	return (
		<React.Suspense fallback={null}>
			<LazyActionShortcutIconOnly action={action} sidebarApi={sidebarApi} product={product} />
		</React.Suspense>
	);
};
